import { request } from "@/interface/helper";

const str = "marketingSubSend";

export const marketingSubSend = {
  [`${str}`]: {
    getList: data => request({ data, method: "get", url: "/send/list" }),
    add: data => request({ data, method: "post", url: "/send/add" }),
    detail: data => request({ data, method: "post", url: "/send/detail" }),
    edit: data => request({ data, method: "post", url: "/send/modify" })
  }
};
